export const Filter = {
  YearAndMonth: "yearAndMonth" as const,
  PersonId: "personId" as const,
  PersonName: "personName" as const,
  Types: "types" as const,
}

export const CreateLeave = {
  DeviationType: "deviationType" as const,
  PersonId: "personId" as const,
  PersonName: "personName" as const,
  CustomName: "customName" as const,
  YearAndMonth: "yearAndMonth" as const,
  ChildName: "childName" as const,
  FromDate: "fromDate" as const,
  ToDate: "toDate" as const,
  Comment: "comment" as const,
  DayHours: "dayHours" as const,
  FillDayHours: "fillDayHours" as const,
  RestrictDateRange: "restrictDateRange" as const,
  HasConnectedTimeReports: "hasConnectedTimeReports" as const,
  IsAdminOnlyType: "isAdminOnlyType" as const,
}

export const CreateAllowance = {
  DeviationType: "deviationType" as const,
  YearAndMonth: "yearAndMonth" as const,
  PersonId: "personId" as const,
  PersonName: "personName" as const,
  CustomName: "customName" as const,
  FromDate: "fromDate" as const,
  ToDate: "toDate" as const,
  FromTime: "fromTime" as const,
  ToTime: "toTime" as const,
  WorkHours: "workHours" as const,
  WorkMinutes: "workMinutes" as const,
  SumDescriptions: "sumDescriptions" as const,
  MealDeductions: "mealDeductions" as const,
  Comment: "comment" as const,
  Mileage: "mileage" as const,
  VehicleType: "vehicleType" as const,
  VehicleTypeName: "vehicleTypeName" as const,
  CountryCode: "countryCode" as const,
  CountryName: "countryName" as const,
  RestrictDateRange: "restrictDateRange" as const,
  HasConnectedTimeReports: "hasConnectedTimeReports" as const,
  IsAdminOnlyType: "isAdminOnlyType" as const,
}

export const HoursByDay = {
  Id: "id" as const,
  Day: "day" as const,
  Hours: "hours" as const,
  Minutes: "minutes" as const,
}

export const HoursByDayWithMeta = {
  MaxTotalMinutes: "maxTotalMinutes" as const,
}

export const SumDescription = {
  Id: "id" as const,
  Sum: "sum" as const,
  Description: "description" as const,
  Hours: "hours" as const,
  Minutes: "minutes" as const,
}

export const SalaryDeviationMeal = {
  Id: "id" as const,
  Day: "day" as const,
  Breakfast: "breakfast" as const,
  Lunch: "lunch" as const,
  Dinner: "dinner" as const,
}

export const SalarySpecificationUser = {
  Id: "id" as const,
  PersonName: "personName" as const,
}

export const WintDeviationCreate = {
  Employee: "employee" as const,
  DeviationType: "deviationType" as const,
  Deviation: "deviation" as const,
  Comment: "comment" as const,
  TimeDeviation: "timeDeviation" as const,
  Amount: "amount" as const,
  TravelCompensation: "travelCompensation" as const,
  TimeBalances: "timeBalances" as const,
  Withdrawal: "withdrawal" as const,
  FuelBenefit: "fuelBenefit" as const,
  IsFullDeviationLoaded: "isFullDeviationLoaded" as const,
  Child: "child" as const,
  UseCurrentMonthPlacement: "useCurrentMonthPlacement" as const,
}

export const HourMinutes = {
  Hours: "hours" as const,
  Minutes: "minutes" as const,
}

export const TimeDeviationCreate = {
  DateRange: "dateRange" as const,
  SelectedPeriod: "selectedPeriod" as const,
  ReportType: "reportType" as const,
  DayHours: "dayHours" as const,
  FillDayHours: "fillDayHours" as const,
  Time: "time" as const,
  Percentage: "percentage" as const,
  YearMonthStates: "yearMonthStates" as const,
}

export const AmountCreate = {
  Form: "form" as const,
  YearMonth: "yearMonth" as const,
  SumDescriptions: "sumDescriptions" as const,
}

export const TimeBalancesCreate = {
  YearMonth: "yearMonth" as const,
  Value: "value" as const,
}

export const WithdrawalCreate = {
  YearMonth: "yearMonth" as const,
  Amount: "amount" as const,
}

export const FuelBenefitCreate = {
  YearMonth: "yearMonth" as const,
  FuelCost: "fuelCost" as const,
  PrivateDistance: "privateDistance" as const,
  BusinessDistance: "businessDistance" as const,
}

export const TravelCompensationCreate = {
  FromDate: "fromDate" as const,
  ToDate: "toDate" as const,
  FromTime: "fromTime" as const,
  ToTime: "toTime" as const,
  MealDeductions: "mealDeductions" as const,
  CountryCode: "countryCode" as const,
}

export const WintSalaryDeviationReportFilter = {
  YearMonthRange: "yearMonthRange" as const,
  PersonSearchName: "personSearchName" as const,
  Persons: "persons" as const,
  CategoryTypes: "categoryTypes" as const,
  DeviationTypes: "deviationTypes" as const,
  EmployeeSearchName: "employeeSearchName" as const,
}

export const WintDeviationDelete = {
  PeriodSelection: "periodSelection" as const,
}

